function NotificationDeleteDrawerController(
  $scope,
  $uibModalInstance,
  $translate,
  notificationService,
  notification,
  toastWrapperService
) {
  $scope.notification = notification;

  $scope.close = () => {
    $uibModalInstance.dismiss();
  };

  $scope.delete = () => {
    notificationService.delete($scope.notification)
      .then(() => {
        toastWrapperService.createToast($translate.instant('NOTIFICATION_DELETED'), 'success');
        $uibModalInstance.close();
      }, () => {
        toastWrapperService.createToast($translate.instant('ERROR_DELETING_NOTIFICATION'), 'danger');
      });
  };
}

const arr = [
  '$scope',
  '$uibModalInstance',
  '$translate',
  'notificationService',
  'notification',
  'toastWrapperService',
  NotificationDeleteDrawerController
];

module.exports = (ngModule) => {
  ngModule.controller('NotificationDeleteDrawerController', arr);
};
